module.exports = __webpack_public_path__ + "stylesheets/video-slider_b3aad2fe71e3a868cc5aad8b42fad8f0.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/video-slider.less
// module id = KApX
// module chunks = 51